import { Link } from "react-router-dom";
import { ArrowRight, BarChart3, BookOpen, Calculator, Clock } from "lucide-react";

const POINTS = [
  [Calculator, "Mathematics — Years 3 to 6", "Step-by-step lessons that build number confidence."],
  [BookOpen, "English — Years 3 to 6", "Reading, writing, spelling and grammar practice."],
  [BarChart3, "Quizzes & progress tracking", "Interactive quizzes, with progress parents can follow."],
];

export default function EducationComingSoon() {
  return (
    <div data-testid="education-coming-soon">
      <section className="relative overflow-hidden border-b border-white/5">
        <img src="https://images.unsplash.com/photo-1503676260728-1c00da094a0b?crop=entropy&cs=srgb&fm=jpg&q=75&w=1920" alt="" className="absolute inset-0 w-full h-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A] via-[#0A0A0A]/85 to-[#0A0A0A]/40" />
        <div className="relative max-w-[1240px] mx-auto px-6 lg:px-10 py-24 lg:py-32 mkt-rise">
          <div className="flex flex-wrap items-center gap-3 mb-5">
            <div className="label-eyebrow">HOH Education</div>
            <span className="inline-flex items-center gap-1.5 text-[10px] tracking-[0.25em] uppercase font-semibold px-2.5 py-1 rounded bg-amber-400 text-black" data-testid="education-badge"><Clock size={11} /> Coming soon</span>
          </div>
          <h1 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-white leading-[1.03] max-w-3xl">
            Maths & English for <span className="italic text-[#D4AF37]">Years 3–6</span>
          </h1>
          <p className="mt-6 text-neutral-300 text-base lg:text-lg max-w-2xl leading-relaxed">
            Interactive lessons, quizzes and progress tracking that help primary children grow in confidence. We're building it now — it isn't available to buy or subscribe to yet.
          </p>
          <div className="mt-10 flex flex-wrap gap-4">
            <Link to="/contact" data-testid="education-register-interest" className="btn-gold px-7 py-3.5 rounded inline-flex items-center gap-2 text-xs tracking-widest uppercase font-semibold">Register interest <ArrowRight size={15} /></Link>
            <Link to="/" data-testid="education-back-home" className="btn-ghost-gold px-7 py-3.5 rounded inline-flex items-center gap-2 text-xs tracking-widest uppercase font-semibold">Back to marketplace</Link>
          </div>
        </div>
      </section>
      <section className="max-w-[1240px] mx-auto px-6 lg:px-10 py-20 grid sm:grid-cols-3 gap-5">
        {POINTS.map(([Icon, t, d]) => (
          <div key={t} className="luxury-card rounded-xl p-6">
            <Icon className="text-[#D4AF37]" size={22} />
            <h3 className="font-serif-display text-2xl text-white mt-4">{t}</h3>
            <p className="text-sm text-neutral-400 mt-2 leading-relaxed">{d}</p>
          </div>
        ))}
      </section>
    </div>
  );
}
